import { shape, string, number } from '@thd-nucleus/data-sources';

export const redeemPerksModel = {
  perkSourceUUID: string(),
  giftCard: {
    availableBalance: number(),
    barCode: string(),
    omniBarCode: string(),
    pin: string(),
  }
};
